import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';

import Alert from '../Alert.jsx';

export default class GuestCreatedModal extends React.Component {
  hideModal() {
    const { hideModal } = this.props;
    hideModal();
  }

  render() {
    return (
      <Alert
        type="success"
        visible
        onOutsideClick={() => this.hideModal()}
        title={<Entity entity="modalTitle" data={{ modal: 'guestCreated' }} />}
        message={<Entity entity="modalMessage" data={{ modal: 'guestCreated' }} />}
        onConfirm={() => this.hideModal()}
      />
    );
  }
}
